/* tslint:disable */
/* eslint-disable */
/**
 * Borrower API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AddressDto } from './AddressDto';
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
    AddressDtoToJSONTyped,
} from './AddressDto';

/**
 * 
 * @export
 * @interface RenegotiationDto
 */
export interface RenegotiationDto {
    /**
     * 
     * @type {string}
     * @memberof RenegotiationDto
     */
    currentLoanNumber: string;
    /**
     * 
     * @type {string}
     * @memberof RenegotiationDto
     */
    entityName: string;
    /**
     * 
     * @type {AddressDto}
     * @memberof RenegotiationDto
     */
    entityAddress: AddressDto;
    /**
     * 
     * @type {string}
     * @memberof RenegotiationDto
     */
    commercialLastName: string;
    /**
     * 
     * @type {string}
     * @memberof RenegotiationDto
     */
    commercialFirstName: string;
    /**
     * 
     * @type {string}
     * @memberof RenegotiationDto
     */
    commercialPhone: string;
    /**
     * 
     * @type {string}
     * @memberof RenegotiationDto
     */
    commercialEmail: string;
}

/**
 * Check if a given object implements the RenegotiationDto interface.
 */
export function instanceOfRenegotiationDto(value: object): value is RenegotiationDto {
    if (!('currentLoanNumber' in value) || value['currentLoanNumber'] === undefined) return false;
    if (!('entityName' in value) || value['entityName'] === undefined) return false;
    if (!('entityAddress' in value) || value['entityAddress'] === undefined) return false;
    if (!('commercialLastName' in value) || value['commercialLastName'] === undefined) return false;
    if (!('commercialFirstName' in value) || value['commercialFirstName'] === undefined) return false;
    if (!('commercialPhone' in value) || value['commercialPhone'] === undefined) return false;
    if (!('commercialEmail' in value) || value['commercialEmail'] === undefined) return false;
    return true;
}

export function RenegotiationDtoFromJSON(json: any): RenegotiationDto {
    return RenegotiationDtoFromJSONTyped(json, false);
}

export function RenegotiationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenegotiationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'currentLoanNumber': json['currentLoanNumber'],
        'entityName': json['entityName'],
        'entityAddress': AddressDtoFromJSON(json['entityAddress']),
        'commercialLastName': json['commercialLastName'],
        'commercialFirstName': json['commercialFirstName'],
        'commercialPhone': json['commercialPhone'],
        'commercialEmail': json['commercialEmail'],
    };
}

export function RenegotiationDtoToJSON(json: any): RenegotiationDto {
    return RenegotiationDtoToJSONTyped(json, false);
}

export function RenegotiationDtoToJSONTyped(value?: RenegotiationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentLoanNumber': value['currentLoanNumber'],
        'entityName': value['entityName'],
        'entityAddress': AddressDtoToJSON(value['entityAddress']),
        'commercialLastName': value['commercialLastName'],
        'commercialFirstName': value['commercialFirstName'],
        'commercialPhone': value['commercialPhone'],
        'commercialEmail': value['commercialEmail'],
    };
}

